import { Box, Container, Grid, Typography } from "@mui/material";
import Contact from "./Contact";
import Pages from "./Pages";
import Copyrights from "./Copyrights";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "grey.900",
        color: "grey.100",
        pt: 5,
        pb: 2,
        ".MuiLink-root": {
          color: "grey.300",
          "&:hover": { color: "primary.main" },
        },
        ".MuiListItemIcon-root": { color: "grey.400" },
        ".MuiListItemButton-root": {
          borderColor: "grey.800",
          "&:hover": { color: "primary.main" },
        },
        ".active": { color: "primary.main" },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Pages />
          </Grid>
          <Grid item xs={12} md={6}>
            <Contact />
          </Grid>
        </Grid>

        <Box pt={3} borderTop="1px solid" borderColor="grey.800">
          <Typography variant="body2" align="center" color="grey.500" sx={{ fontSize: "0.875rem" }}>
            <Copyrights />
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
